class SearchByFaq extends HTMLElement {
  constructor() {
    super();
    this.predictiveSearch = this.closest("predictive-search");
    this.faq = window.faq || [];
    this.query = this.dataset.query;
    this.faqResults = [];
    this.results = this.querySelector("[data-faq-results]");

    this.setFaqResults();
    this.render();
  }

  setFaqResults() {
    this.faqResults = this.faq.filter((faq) => {
      const question = faq.question.toLowerCase();
      return question.includes(this.query.toLowerCase());
    });
  }

  higlightMatch(text) {
    return text.replace(
      new RegExp(this.query, "gi"),
      (matchedText) => `<strong>${matchedText}</strong>`
    );
  }

  createLink(faq) {
    const url = new URL(window.location);
    url.pathname = this.dataset.faqUrl;
    url.searchParams.set("category", faq.categories[0]);
    url.searchParams.set("question", faq.question);
    return url.toString();
  }

  render() {
    this.predictiveSearch.setFaqResults(!!this.faqResults.length);
    if (!this.faqResults.length) return;

    let html = "";

    this.faqResults.forEach((faq, index) => {
      if (index > 4) return;
      const higlightedQuestion = this.higlightMatch(faq.question);
      const link = this.createLink(faq);

      html += `<li class="predictive-search__page-suggestion">
          <a class="predictive-search__page-suggestion-link" href="${link}">${higlightedQuestion}</a>
        </li>`;
    });

    this.results.innerHTML = html;
    this.classList.remove("hidden");
  }
}

customElements.define("search-by-faq", SearchByFaq);
